import axiosInstance from "../../../services/api/axiosInstance";
import backgroundAxiosInstance from "../../../services/api/backgroundAxiosInstance";

export const getAllClass = async (obj, isBackground = false) => {
    try {
        const response = await (isBackground ? backgroundAxiosInstance : axiosInstance).get(`/class/all`, {params : obj});
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
    }
}

export const assignClass = async (sectionId, teacherId) => {
    try {
        const response = await axiosInstance.post(`/class/assign-class/${sectionId}/${teacherId}`,);
        return response;

    } catch (error) {
        console.error("Error submitting form:", error);
    }
}